import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentWrapper from '@/components/LandingPages/ContentWrapper/ContentWrapper';
import HeroSection from '@/components/LandingPages/HeroSection/HeroSection';
import ScrollContentButton from '@/components/ui/ScrollContentButton/ScrollContentButton';
import FinalCTA from '../FinalCTA/FinalCTA';
import GettingStarted from '../GettingStarted/GettingStarted';
import SellingPointsContainer from '../SellingPointsContainer/SellingPointsContainer';
import TestimonialsContainer from '../TestimonialsContainer/TestimonialsContainer';
import TrustSignalContainer from '../TrustSignalContainer/TrustSignalContainer';
export default function OrganizersContainer() {
    var heroUrl = "".concat(process.env.CDN_URL, "/static-images/organizers/hero.jpg");
    return (_jsxs("div", { className: "w-full bg-neutral-50", "data-testid": "homepage-container", id: "homepage-container", children: [_jsx("div", { className: "w-full mb-[1.5rem]", "data-testid": "homepage-hero-container", children: _jsx(HeroSection, { buttons: [
                        {
                            ariaLabel: 'Start a Campaign',
                            label: 'Start a Campaign',
                            testId: 'organizers-hero-cta',
                            url: '/onboarding',
                        },
                    ], imageUrl: heroUrl, title: "Fund Your Fight for Social Justice" }) }), _jsxs(ContentWrapper, { children: [_jsx(SellingPointsContainer, {}), _jsx(TrustSignalContainer, {}), _jsx(TestimonialsContainer, {}), _jsx(GettingStarted, {}), _jsx(FinalCTA, {}), _jsx(ScrollContentButton, { contentId: "movement-button-section" })] })] }));
}
